// Copyright (c) 2017 Deere & Company

import t from 'tcomb';

const GridApi = t.struct({
    dateFields: t.list(t.String)
});

export const getDefaultState = () =>
    new GridApi({
        dateFields: [
            'failureDate',
            'repairDate',
            'originalSubmissionDate',
            'dateIssued',
            'deliveryDate',
            'basicWarrantyStartDate',
            'basicWarrantyEndDate'
        ]
    });

export default GridApi;



// WEBPACK FOOTER //
// ./src/reports/credit-memo/state/grid-api.js